import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useFirebaseContext } from '../../../context';
import { googleAuthProvider, timestamp } from '../../../lib';
import * as ROUTES from '../../../constants';
import { DEFAULT_COLOR, DEFAULT_COLORL2 } from '../../../constants';
import { ResetPassword } from '.';
import { Core } from '../..';
import { CSSTransition } from 'react-transition-group';
import '../../core/styles/styles.css';
import { FaEnvelope, FaUserAlt } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';
import { BottomLink } from './styles';
import { getDate } from '../../../helpers';

export default function Signin({
  showSignInBox,
  setShowSignInBox,
  setShowSignUpBox,
}) {
  const history = useHistory();
  const { firebase } = useFirebaseContext();
  const [emailAddress, setEmailAddress] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const boxRef = useRef();
  const containerRef = useRef();
  const [showResetPasswordBox, setShowResetPasswordBox] = useState(false);
  const [forwardedHeight, setForwardedHeight] = useState('auto');
  const [progress, setProgress] = useState(0);

  const isInvalid = password === '' || emailAddress === '';

  useEffect(() => {
    if (!showSignInBox) {
      setShowResetPasswordBox(false);
      setError('');
    }
  }, [showSignInBox]);

  const setWelcomeLists = (passedUser) => {
    if (passedUser.additionalUserInfo.isNewUser) {
      const userDB = firebase
        .firestore()
        .collection('users')
        .doc(firebase.auth().currentUser.uid);
      const taskDB = userDB.collection('tasks');
      const listDB = userDB.collection('lists');
      const tempModifiedAt = timestamp.now().toMillis();

      const tempList = {
        order: 0,
        name: 'Hello 👋',
        color: 0,
        taskCount: 2,
        modifiedAt: tempModifiedAt,
      };

      listDB.add(tempList).then((doc) => {
        listDB.add({
          order: 1,
          name: 'Personal 😎',
          color: 2,
          taskCount: 0,
          modifiedAt: tempModifiedAt,
        });

        listDB.add({
          order: 2,
          name: 'Reading List 📚',
          color: 4,
          taskCount: 0,
          modifiedAt: tempModifiedAt,
        });

        listDB.add({
          order: 3,
          name: 'Fitness 💪',
          color: 6,
          taskCount: 0,
          modifiedAt: tempModifiedAt,
        });

        listDB.add({
          order: 4,
          name: 'Shopping 🛒',
          color: 8,
          taskCount: 0,
          modifiedAt: tempModifiedAt,
        });

        tempList.docID = doc.id;

        const listPrompt = {
          order: 0,
          important: false,
          listID: tempList.docID,
          title: 'Create a new List 🏷️',
          note: '',
          date: getDate(true, new Date()),
          time: '',
          modifiedAt: tempModifiedAt,
        };

        const taskPrompt = {
          order: 1,
          important: false,
          listID: tempList.docID,
          title: 'Create a new Task 📌',
          note: '',
          date: getDate(true, new Date()),
          time: '',
          modifiedAt: tempModifiedAt,
        };

        taskDB.add(listPrompt).then(() => {
          taskDB.add(taskPrompt).then(() => {
            history.push('/');
            history.push(ROUTES.DASHBOARD);
          });
        });
      });
    }
  };

  useEffect(() => {
    if (boxRef && boxRef.current)
      setForwardedHeight(boxRef.current.clientHeight);
  }, [showResetPasswordBox]);

  const handleSignIn = (event) => {
    event.preventDefault();
    setProgress(95);

    firebase
      .auth()
      .signInWithEmailAndPassword(emailAddress, password)
      .then(() => {
        history.push(ROUTES.DASHBOARD);
      })
      .catch((error) => {
        setProgress(100);
        setEmailAddress('');
        setPassword('');
        setError(error.message);
      });
  };

  const handleGuestSignIn = () => {
    setProgress(95);

    firebase
      .auth()
      .signInAnonymously()
      .then((result) => {
        result.user.updateProfile({
          displayName: 'Guest',
        });

        setWelcomeLists(result);
      })

      .catch((error) => {
        setProgress(100);
        setError(error.message);
      });
  };

  return (
    <>
      <Core.Loading
        color={DEFAULT_COLOR}
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />

      <Core.CardContainer
        forwardedRef={containerRef}
        showBox={showSignInBox}
        setShowBox={setShowSignInBox}
        width='25vw'
        minWidth='392px'
      >
        <Core.Slider screen='Signin' showBox={showResetPasswordBox}>
          <CSSTransition
            in={!showResetPasswordBox}
            timeout={300}
            classNames='display'
            unmountOnExit
          >
            <div
              ref={boxRef}
              style={{
                transition: 'all 0.2s ease-in-out',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Core.Title>Sign In.</Core.Title>

              <Core.ListLayout>
                {showSignInBox && error != '' && (
                  <Core.Error>{error}</Core.Error>
                )}
                <Core.Input
                  placeholder='Email address'
                  value={emailAddress}
                  onChange={({ target }) => setEmailAddress(target.value)}
                  style={{ marginBottom: '10px' }}
                />

                <Core.Input
                  type='password'
                  placeholder='Password'
                  autoComplete='off'
                  value={password}
                  onChange={({ target }) => setPassword(target.value)}
                  style={{ marginBottom: '10px' }}
                />

                <Core.Button
                  disabled={isInvalid}
                  onClick={(e) => {
                    setError('');
                    handleSignIn(e);
                  }}
                  color={'white'}
                  bg={DEFAULT_COLOR}
                  style={{ marginBottom: '10px' }}
                >
                  <div
                    style={{
                      width: '100%',
                      justifyContent: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      position: 'relative',
                    }}
                  >
                    <FaEnvelope
                      style={{ height: '100%', position: 'absolute', left: 0 }}
                    />
                    <span>Sign In</span>
                  </div>
                </Core.Button>

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Core.Link
                    onClick={() => {
                      setError('');
                      setShowResetPasswordBox(true);
                    }}
                  >
                    Forgot password
                  </Core.Link>
                </div>

                <Core.Button
                  color={DEFAULT_COLOR}
                  bg={DEFAULT_COLORL2}
                  shadowBorder={true}
                  style={{ marginTop: '10px', marginBottom: '10px' }}
                  type='button'
                  onClick={() => {
                    setError('');
                    firebase
                      .auth()
                      .signInWithPopup(googleAuthProvider)
                      .then((result) => setWelcomeLists(result))
                      .catch((error) => {
                        setError(error.message);
                      });
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      justifyContent: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      position: 'relative',
                    }}
                  >
                    <img
                      src='https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg'
                      style={{ height: '100%', position: 'absolute', left: 0 }}
                    />

                    {useMediaQuery({
                      maxWidth: 322,
                    }) ? (
                      <span>Google</span>
                    ) : (
                      <span>Sign in with Google</span>
                    )}
                  </div>
                </Core.Button>

                <Core.Button
                  color={DEFAULT_COLOR}
                  bg={DEFAULT_COLORL2}
                  shadowBorder={true}
                  type='button'
                  onClick={() => {
                    setError('');
                    handleGuestSignIn();
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      justifyContent: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      position: 'relative',
                    }}
                  >
                    <FaUserAlt
                      style={{ height: '100%', position: 'absolute', left: 0 }}
                    />
                    {useMediaQuery({
                      maxWidth: 322,
                    }) ? (
                      <span>Guest</span>
                    ) : (
                      <span>Sign in as Guest</span>
                    )}
                  </div>
                </Core.Button>
                <BottomLink
                  style={{
                    marginTop: '24px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <span style={{ opacity: 0.55, marginRight: '10px' }}>
                    No account yet?
                  </span>
                  <Core.Link
                    onClick={() => {
                      setShowSignInBox(false);
                      setShowSignUpBox(true);
                    }}
                  >
                    Sign up now
                  </Core.Link>
                </BottomLink>
              </Core.ListLayout>
            </div>
          </CSSTransition>

          <CSSTransition
            in={showResetPasswordBox}
            timeout={300}
            classNames='display'
            unmountOnExit
          >
            <ResetPassword
              forwardedHeight={forwardedHeight}
              showResetPasswordBox={showResetPasswordBox}
              setShowResetPasswordBox={setShowResetPasswordBox}
            />
          </CSSTransition>
        </Core.Slider>
      </Core.CardContainer>
    </>
  );
}
